module.exports = flarum.core.compat['components/LogInButton'];